import React from 'react';
import { Link } from 'react-router-dom';

const SitemapPage = ({ menuItems, language }) => {
  return (
    <div className="min-h-screen bg-orange-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto bg-white p-8 rounded-lg shadow-md border-t-4 border-green-600">
        <h1 className="text-3xl font-bold text-green-800 mb-6 border-b pb-4">
          {language === 'en' ? 'Site Map' : 'தள வரைபடம் (Site Map)'}
        </h1>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {menuItems.map((section, idx) => (
            <div key={idx} className="bg-gray-50 p-4 rounded-md shadow-sm border border-gray-100">
              {section.children ? (
                <>
                  <h2 className="text-xl font-bold text-orange-700 mb-3 border-b-2 border-orange-200 inline-block pb-1">
                    {language === 'en' ? section.label_en : section.label_ta}
                  </h2>
                  <ul className="space-y-2 mt-2">
                    {section.children.map((child, cidx) => (
                      <li key={cidx} className={child.isHeader ? 'mt-4 mb-1' : 'ml-4 list-disc text-gray-700 marker:text-green-500'}>
                        {child.isHeader ? (
                          <span className="font-semibold text-gray-500 uppercase text-xs tracking-wider">
                            {language === 'en' ? child.label_en : child.label_ta}
                          </span>
                        ) : (
                          <Link to={child.slug} className="hover:text-green-700 hover:underline transition-colors">
                            {language === 'en' ? child.label_en : child.label_ta}
                          </Link>
                        )}
                      </li>
                    ))}
                  </ul>
                </>
              ) : (
                <h2 className="text-xl font-bold text-orange-700 mb-2">
                  <Link to={section.slug} className="hover:underline">
                    {language === 'en' ? section.label_en : section.label_ta}
                  </Link>
                </h2>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SitemapPage;
